import { Type } from '@angular/core';

export class SurveyItem {
    constructor(public component: Type<any>, public survey: any) {
    }
}